import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_URL = `${
  import.meta.env.VITE_FOUNDATION_API
}/nsportal/Users/verify-email`;

export const GET_USER_VERIFY_EMAIL = 'user-verify-email';

async function query({ token }: { token: string }) {
  const response = await axios.get(`${API_URL}?token=${token}`);
  return response.data;
}

export function useGetUserVerifyEmail({ token }: { token: string }) {
  return useQuery({
    queryKey: [GET_USER_VERIFY_EMAIL, token],
    queryFn: () => query({ token }),
    refetchOnWindowFocus: false,
    retry: false,
  });
}
